import React from 'react';
import { showView } from '../MenuSide/menuSideSlice';
import './MenuSide.scss';
import Config from '../../../config/config';



import {loadMenuNodes, loadMenuNodesPrivate, showAccount,  showLibrary,  
    showMessages, showContacts} from "../MenuSide/menuSideSlice";
import { getInitialState, closeQuizView } from '../../MainVIew/Quiz/quizSlice.js';
import { closeAllView, setSelectModule, showMenuView, closeAllViewCloseQuizActive } from '../MenuSide/menuSideSlice';
import avatar_img from '../../../styles/avatar_default.png';
import { updateMessagesAdmin, updateMessagesDataInbox, updateMessagesDataSend, 
    updateMessagesDataBuisness } from "../../MainVIew/Messages/messageslice.js";




const MenuSide = (props) => {
 const {dispatch } = props;
 const serverPath = Config.serverPath;
// var output = document.getElementById('avatar-image');
 const avatarName = props.authData.avatarName;
 //const avatarPath=`${serverPath}/api/avatar/28/${props.accountData.avatarName}`;
////console.log(avatarName);
const userId = props.authData.id;
let avatar_src = avatar_img;
if (avatarName.user_image_name) {
    avatar_src = `${serverPath}/api/avatar/${userId}/${props.authData.avatarName.user_image_name}`;
}
//const avatar_src = avatarName.user_image_name? `${serverPath}/api/avatar/${userId}/${props.authData.avatarName.user_image_name}`: avatar_img;



//SHOW SUBSCRIBER
   const onShowSubsciber = (e) => {
 const numberModule = e.currentTarget.value;
    dispatch(showMenuView());
   
    dispatch(closeAllViewCloseQuizActive());
    dispatch(showView(numberModule));

   };

//SHOW ACCOUNT
   const onShowAccount = (e) => {
    const numberModule = e.currentTarget.value;
    dispatch(showMenuView());
    dispatch(setSelectModule(numberModule));

    dispatch(closeAllView());
    dispatch(closeQuizView());
    dispatch(showAccount());

   };
//SHOW FAVORITES
const onShowFavorites = (e) => {
    const numberModule = e.currentTarget.value;
    dispatch(showMenuView());
    //dispatch(setSelectModule(numberModule));
    dispatch(closeAllViewCloseQuizActive());
    dispatch(showView(numberModule));

    //dispatch(closeAllView());
    //dispatch(closeQuizView());
    //dispatch(showFavorites());

   };
//SHOW Messages
const onShowMessages = (e) => {
    const numberModule = e.currentTarget.value;
    dispatch(showMenuView());
    dispatch(setSelectModule(numberModule));

    const messagesData = props.authData.messages;
    const id = props.authData.id;
    //console.log(messagesData);
    //console.log(userId);
    //SORT MESSAGE DATA
    const sortMessagesData = (data, userId) => {

        //console.log('1.1.1 START SORT MESSAGE DATA');

        let messagesUserDataInbox = [];
        let messagesUserDataSend = [];
        let messagesDataAdmin = [];
        let messagesDataBuisness = [];

            //TO INBOX
            //console.log(data);
        for (let i=0; i < data.length ; i++) {
            //console.log('1.1.1.1 START 1');
            //console.log(data[i].user);
            let  dataUserId = data[i].user.id;
            //console.log(dataUserId );
          
            if (((userId === dataUserId) && (data[i].mesCategory === 2))||((userId === dataUserId) && (data[i].mesCategory === 1))) {
                //console.log('1.1.1.1 START 1');
                ////console.log(data[i].userId);
                ////console.log(data[i].mesCategory);
               // //console.log(data[i]);
                ////console.log(data.length);
                messagesUserDataSend.push(data[i]);
                
            //TO SEND
            } 
            if ((userId !== dataUserId) && (data[i].mesCategory === 2)) {
                //console.log('1.1.1.2 START 2');
                messagesUserDataInbox.push(data[i]);
            //TO ADMIN
        } 
        
            if (((userId !== dataUserId) && (data[i].mesCategory === 1))||((userId === dataUserId) && (data[i].mesCategory === 1))) {
            //console.log('1.1.1.3 START 3');
                messagesDataAdmin.push(data[i]);
            }
            //TO BUISNESS
            
            if ((userId !== dataUserId) && (data[i].mesCategory === 3)) {
                //console.log('1.1.1.1 START 4');
                messagesDataBuisness.push(data[i]);
            }
                
        }
        dispatch(updateMessagesDataInbox(messagesUserDataInbox));
        dispatch(updateMessagesDataSend(messagesUserDataSend));
        dispatch(updateMessagesAdmin(messagesDataAdmin));
        dispatch(updateMessagesDataBuisness(messagesDataBuisness))
        //console.log(messagesUserDataInbox);
        //console.log(messagesUserDataSend);
        //console.log(messagesDataAdmin);
        //console.log(messagesDataBuisness);

     }
     if (messagesData) {
     sortMessagesData(messagesData, id);
     }
     //
     dispatch(closeAllViewCloseQuizActive());
     dispatch(closeQuizView());
     dispatch(showMessages());

   };

//SHOW LIBRARY
const onShowLibrary = (e) => {
    const numberModule = e.currentTarget.value;
    dispatch(showMenuView());
    dispatch(setSelectModule(numberModule));

    dispatch(closeAllViewCloseQuizActive());
    dispatch(closeQuizView());
    dispatch(showLibrary());

   }; 
//SHOW TROUBLES
/*
const onShowTroubles= (e) => {
    const numberModule = e.target.value;
    dispatch(showMenuView());
    dispatch(setSelectModule(numberModule));

    dispatch(closeAllView());
    dispatch(closeQuizView());
    dispatch(showTroubles());

   }; 
   */ 
   //SHOW CONTACTS
const onShowContacts= (e) => {
    const numberModule = e.currentTarget.value;
    dispatch(showMenuView());
    dispatch(setSelectModule(numberModule));

    dispatch(closeAllViewCloseQuizActive());
    dispatch(closeQuizView());
    dispatch(showContacts());

   };     

//SHOW TASKS
const onShowTasks = (e) => {
    const numberModule = e.currentTarget.value;
    dispatch(showMenuView());
   
    dispatch(closeAllViewCloseQuizActive());
    dispatch(showView(numberModule));

   };


//SHOW BEGINNING STATE
const onShowBeginning = (e) => {
    const numberModule = e.currentTarget.value;
   // console.log(numberModule);
    dispatch(showMenuView());
    //dispatch(setSelectModule(numberModule));
    dispatch(closeAllViewCloseQuizActive());
    dispatch(showView(numberModule));
   // dispatch(closeAllView());
   // dispatch(closeQuizView());
    //dispatch(showFirstContentView());
    
};


// SET ID CATEGORY AND FETCH, если курсы то другая функция
      const onShowCategoryRedux = (e) => {
        const numberModule = e.currentTarget.value;
        dispatch(getInitialState());
        dispatch(showMenuView());
        dispatch(showView(numberModule));
        //dispatch(setSelectModule(numberModule));
       
        dispatch(closeAllViewCloseQuizActive());
        dispatch(loadMenuNodes());
        
           // dispatch(openCategoryView());
            
        
      };
// PRIVATE MENUSIDE
const onShowCategoryPrivateRedux = (e) => {
    const numberModule = e.currentTarget.value;
    dispatch(getInitialState());
    dispatch(showMenuView());
    dispatch(showView(numberModule));
    //dispatch(setSelectModule(numberModule));
   
    dispatch(closeAllViewCloseQuizActive());
    dispatch(loadMenuNodesPrivate(props.authData.id));
   
       // dispatch(openCategoryView());
        
    
  };



//STYLE SELECTED MODULE

if (props.menuSideView) {

const selectedModule = Number(props.selectedModule);
////console.log(selectedModule);

        return (


            <div className="MenuSide ">
                <div className='menu-avatar'>
                    <img id='avatar-image' src={avatar_src} alt="Avatar" className="avatar"/>
                    <div className='container'>
                        <span className='avatar-name' >{props.authData.username}</span>
                        <br></br>
                        <span className='avatar-occupation'>{props.authData.usercountry}</span>
                        <br></br>
                        <span className='avatar-occupation'>{props.authData.occupation}</span>
                        <br></br>
                        <span className='avatar-subscription'>{props.authData.subscription}</span>
                    </div>

                </div>
                <hr></hr>
                <div >
                <ul>
                    {/* <li>
                        <button onClick={onShowCategoryRedux} value="0"> Курсы </button>
                    </li> */}
                    <li>
                        {/*<button id="begining" className='selected' onClick={onShowBeginning}> Начало </button>*/}
                        <button  value ="1" className= {selectedModule === 1 ? 'begining-selected':'begining'} onClick={onShowBeginning}><span>Начало</span></button>
                    </li>
                    <li>
                        <button value ="2" className={selectedModule === 2 ? 'modules-selected':"modules"}  onClick={onShowCategoryRedux} ><span>Модули</span></button>
                        {/* <button onClick={onShowCategoryRedux} value="2">Example</button> */}
                    </li>
                    {/*<li>
                        <button value ="12" className={selectedModule === 12 ? 'addmodules-selected':"addmodules"}   ><span>Создать*</span></button>
                        
                    </li>*/}
                    
                    {(props.authData.modulesName[1].status || (props.authData.userRole[0].role_id === 1)) ? <li>
                        <button value ="14" className={selectedModule === 14 ? 'trouble-selected':"trouble"} ><span>Вопросы*</span></button>
                    </li> : null}
                    {(props.authData.modulesName[4].status || (props.authData.userRole[0].role_id === 1)) ? <li>
                        <button value ="4" className={selectedModule === 4 ? 'lit-selected':"lit"} onClick={onShowLibrary}><span>Литература</span></button>
                    </li> : null}
                 
                </ul>
                </div>
                <hr></hr>
                <div >
                    {(props.authData.modulesName[3].status || (props.authData.userRole[0].role_id === 1)) ? <ul>
                        <li>
                            <button value ="5" className={selectedModule === 5 ? 'help-selected':"help"}> <span>Помощь*</span></button>
                        </li>
                        <li>
                            <button value ="6" className={selectedModule === 6 ? 'subscription-selected':"subscription"} onClick={onShowSubsciber}> <span>Подписка*</span></button>
                        </li>
                    </ul> : null}
                
                </div>
                {(props.authData.modulesName[3].status || (props.authData.userRole[0].role_id === 1)) ? <hr></hr> : null}
                <div >
                    <ul>
                        <li>
                            <button value ="7" className={selectedModule === 7 ? 'private-selected':"private"} onClick={onShowAccount}><span>Личный кабинет</span></button>
                        </li>
                        <li>
                            <button value ="8" className={selectedModule === 8 ? 'favorite-selected':"favorite"} onClick={onShowFavorites}><span>Избранное</span><sup>{props.authData.favoriteQuizes.length}</sup> </button>
                        </li>
                        {(props.authData.modulesName[0].status || (props.authData.userRole[0].role_id === 1)) ? <li>
                            <button value ="9" className={selectedModule === 9 ? 'messages-selected':"messages"} onClick={onShowMessages}><span>Сообщения</span></button>
                        </li> : null}
                    </ul>
                    
                </div>
                <hr></hr>
                
                <div>
                     {(props.authData.modulesName[2].status || (props.authData.userRole[0].role_id === 1)) ? <ul>
                        <li>
                            <button value ="10" className={selectedModule === 10 ? 'contacts-selected':"contacts"} onClick={onShowContacts}><span>Контакты</span></button>
                        </li>
                    </ul> : null} 
                    
                </div> 
                {(props.authData.modulesName[2].status || (props.authData.userRole[0].role_id === 1)) ? <hr></hr> : null }
                   
                <div>
                    <ul>
                        <li>
                            <button value ="11" className={selectedModule === 11 ? 'tasks-selected':"tasks"} onClick={onShowTasks}><span>Задачи</span></button>
                        </li>
                    </ul>
                    
                </div>
                <div>
                    <ul>
                        { (props.authData.modulesName[5].status || (props.authData.userRole[0].role_id === 1)) ? <li>
                        <button value ="13" className={selectedModule === 13 ? 'mymodules-selected':"mymodules"}  onClick={onShowCategoryPrivateRedux} ><span>Мои модули</span></button>
                        {/* <button onClick={onShowCategoryRedux} value="2">Example</button> */}
                    </li> : null}
                        <li>
                            <button value ="15" className={selectedModule === 15 ? "tasks-mine-selected":"tasks-mine"} onClick={onShowTasks}><span>Мои задачи</span></button>
                        </li>
                    </ul>
                    
                </div>
            </div>
        )
            
}
    
}
export default MenuSide;